function copyrightYear() {
  const currentYear = new Date().getFullYear()
  document.getElementById('copyright').textContent = currentYear
}

export default copyrightYear
